import { Text, Tooltip } from "@mantine/core"
import clsx from "clsx"
import styles from "./styles.module.css"
import { SimpleFormulaDto } from "../../../../../orval/gen"

export function FormulaHeaderCell({
  formula,
  style,
  orientation,
}: {
  formula: SimpleFormulaDto
  style: React.CSSProperties
  orientation: "normal" | "transpose"
}) {
  return (
    <div className={clsx(styles["cell"], styles["header"])} style={style}>
      <Tooltip label={formula.name} withArrow>
        <Text
          size={"xs"}
          style={
            orientation === "normal"
              ? {
                  writingMode: "vertical-lr",
                  transform: "rotate(-180deg)",
                }
              : undefined
          }
        >
          {formula.code}
        </Text>
      </Tooltip>
    </div>
  )
}
